import { Card, EmptyState, LinkButton } from '@/components/ui';
import { paths } from '@/routes/paths';

/**
 * Shown in place of a result when the plan, not the request, is the problem.
 *
 * `error` is the 403 from the server: its message says what is paid for and
 * its detail says which plan the company is on, so neither is repeated here.
 */
export function PlanUpgradeState({ error }) {
  const detail = error?.errors?.find((item) => item.field === 'plan')?.message;

  return (
    <Card>
      <EmptyState
        title={error?.message ?? 'This is part of a paid plan'}
        description={detail}
        action={
          <LinkButton to={paths.company.billing} size="sm">
            See plans
          </LinkButton>
        }
      />
    </Card>
  );
}
